OE.addPlugin('UserArea', (function(){

    var Plugin = {},
        Options = {
            timeout  : null, // display popup after n seconds
            reappear : 7 * 24 * 60 * 60, // when closed, reappear after n seconds
            scroll   : null, // display popup when user has scrolled the page for n percent,
            pageviews: null, // display popup when the user accesses the n-th page,
            hideifelementexists : null // if this element is found to not show the popup
        },
        class_prefix = 'popup',
        overlay_id = class_prefix + '__overlay';

    Plugin.init = function()
    {
        add_events();
    };

    var add_events = function()
    {
        var field = OE.$doc.querySelector('input[type="file"][name="basic-user-avatar"]');
        if(field)
        {
            field.addEventListener('change', profile_upload_image_has_changed);
        }
    };

    var profile_upload_image_has_changed = function(e)
    {
        if(typeof FileReader !== 'undefined')
        {
            update_uploaded_image_preview(e);
        }
    };

    var getCanvas = function(element)
    {
        var canvas = element.parentElement.querySelector('.userarea-profile__avatar-preview > canvas');

        if(!canvas)
        {
            canvas = OE.$doc.createElement('canvas');
            element.parentElement.querySelector('.userarea-profile__avatar-preview').appendChild(canvas);
        }

        return canvas;
    };

    var update_uploaded_image_preview_without_exif = function(e)
    {
        var reader = new FileReader(),
            canvas = getCanvas(e.target),
            ctx = canvas.getContext('2d');

        reader.onload = function(event){
            var img = new Image();
            img.onload = function() {
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img,0,0);
            };

            img.src = event.target.result;
        };
        reader.readAsDataURL(e.target.files[0]);
    };

    var update_uploaded_image_preview = function(e)
    {
        if(typeof EXIF !== 'undefined')
        {
            var canvas = getCanvas(e.target),
                ctx = canvas.getContext('2d'),
                file = e.target.files[0];

            EXIF.getData(file, function()
            {
                var orientation = EXIF.getTag(this,"Orientation");
                var thisImage = new Image();

                thisImage.onload = function()
                {
                    canvas.width  = thisImage.width;
                    canvas.height = thisImage.height;
                    ctx.save();

                    var width  = canvas.width;  var styleWidth  = canvas.style.width;
                    var height = canvas.height; var styleHeight = canvas.style.height;
                    if (orientation)
                    {
                        if (orientation > 4)
                        {
                            canvas.width  = height; canvas.style.width  = styleHeight;
                            canvas.height = width;  canvas.style.height = styleWidth;
                        }

                        switch (orientation)
                        {
                            case 2: ctx.translate(width, 0);     ctx.scale(-1,1); break;
                            case 3: ctx.translate(width,height); ctx.rotate(Math.PI); break;
                            case 4: ctx.translate(0,height);     ctx.scale(1,-1); break;
                            case 5: ctx.rotate(0.5 * Math.PI);   ctx.scale(1,-1); break;
                            case 6: ctx.rotate(0.5 * Math.PI);   ctx.translate(0,-height); break;
                            case 7: ctx.rotate(0.5 * Math.PI);   ctx.translate(width,-height); ctx.scale(-1,1); break;
                            case 8: ctx.rotate(-0.5 * Math.PI);  ctx.translate(-width,0); break;
                        }
                    }

                    ctx.drawImage(thisImage,0,0);
                    ctx.restore();

                    var dataURL = canvas.toDataURL();
                    // at this point you can save the image away to your back-end using 'dataURL'
                };

                // now trigger the onload function by setting the src to your HTML5 file object (called 'file' here)
                thisImage.src = URL.createObjectURL(file);

            });
        }
        else
        {
            update_uploaded_image_preview_without_exif(e);
        }
    };

    return Plugin;
})());
